import React, { useState } from 'react';
import { Address, InternalAddress, Region } from '../../../../types/orderTypes';
import { getHubConfig } from '../../../../const/HubConfig';
import Dropdown from '../../../../components/dropdown/Dropdown';
import { RadioComponent } from '../../../../ReusableComponents/Radio/RadioComponent';
import Modal from '../../../../components/modals/Modal';
import { updateOrdersPickupLocation } from '../../../../fetch/updateOrdersPickupLocation';

interface Props {
  bundleId: string;
  bundleOrderIds: string[];
  currentPickupAddress: InternalAddress;
  region: Region;
  onCloseModal: (changed: boolean) => void;
}

export const ChangePickupPointModal = ({
  bundleId,
  bundleOrderIds,
  currentPickupAddress,
  region,
  onCloseModal,
}: Props) => {
  const hubConfig = getHubConfig(region);
  const pickupAddresses = [
    hubConfig.hubAddress,
    ...hubConfig.handoverPointAddresses,
  ];
  const [selectedAddress, setSelectedAddress] =
    useState<InternalAddress>(currentPickupAddress);

  const updatePickupPointForOrders = async () => {
    const changed = await updateOrdersPickupLocation(
      bundleOrderIds,
      selectedAddress
    );
    onCloseModal(changed);
  };

  return (
    <Modal
      title={`Change pickup point for bundle ${bundleId}`}
      closeText="Cancel"
      onClose={() => {
        onCloseModal(false);
      }}
      buttons={[
        {
          title: 'Change Pickup Point',
          onClick: updatePickupPointForOrders,
        },
      ]}
    >
      <div>
        <div>
          {pickupAddresses.map(pickupAddress => (
            <RadioComponent
              checked={
                selectedAddress.fullAddressString ==
                pickupAddress.fullAddressString
              }
              id={`hub-${pickupAddress.streetName}`}
              key={`hub-${pickupAddress.streetName}`}
              name={`hub-${pickupAddress.streetName}`}
              onChange={() => setSelectedAddress(pickupAddress)}
              label={{ node: pickupAddress.fullAddressString }}
              value={pickupAddress.fullAddressString}
            ></RadioComponent>
          ))}
        </div>
      </div>
    </Modal>
  );
};
